// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_dc34219"};